import { useMutation } from "@apollo/client";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { TextField } from "@mui/material";
import { useState } from "react";
import { CREATE_RELEASE_SUBCATEGORY } from "../../../../../graphql/mutations";

export default function DialogCreateSubCategory({
    open,
    handleClose,
    fatherId,
    onCreate,
    onError
}) {

    const [createReleaseSubcategory, { loading }] = useMutation(CREATE_RELEASE_SUBCATEGORY)

    const [title, setTitle] = useState("")

    const handleChange = (event) => {
        setTitle(event.target.value)
    }

    const handleSubmit = async () => {
        try {
            await createReleaseSubcategory({
                variables: {
                    release_category_id: fatherId,
                    title: title
                }
            })
            onCreate()
        } catch (e) {
            console.log(e)
            onError()
        }
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Criar tipo"}</DialogTitle>

                <DialogContent>
                    <TextField
                        id="outlined-basic"
                        label="Nome"
                        variant="outlined"
                        fullWidth
                        value={title}
                        onChange={handleChange}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSubmit} color="primary" variant="contained" autoFocus disabled={loading}>
                        {loading && <CircularProgress size={14} style={{ marginRight: 12 }} />}
                        Criar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}